import SimpleBar from 'simplebar';
import helpers from '../helpers';

let sb = null;
let mapLighter;

// точки на миникарте
class Dots {
	constructor(page) {
		this.dots = page.querySelectorAll('.dot');
		this.refs = page.querySelectorAll('.article__map-refs--item');
		this.container = page.querySelector('.article__map-refs');

		this.dataAttrs = {
			dataListItem: 'data-map',
			dataMapItem: 'data-dot',
		};

		this.classNames = {
			active: 'dot--active',
		};

		this.init = () => {
			this.refs.forEach((ref) => {
				ref.addEventListener('mouseenter', (e) => this.link(e));
			});
			this.container.addEventListener('mouseleave', () => this.clear());
		};

		this.destroy = () => {
			this.refs.forEach((ref) => {
				ref.removeEventListener('mouseenter', (e) => this.link(e));
			});
			this.container.removeEventListener('mouseleave', () => this.clear());
		};
	}

	link(e) {
		e.preventDefault();
		const thisRef = e.currentTarget;
		const refData = thisRef.getAttribute(this.dataAttrs.dataListItem);

		this.dots.forEach((dot) => {
			let dotData = dot.getAttribute(this.dataAttrs.dataMapItem);
			dotData === refData ? dot.classList.add(this.classNames.active) : dot.classList.remove(this.classNames.active);
		});
	}

	clear() {
		this.dots.forEach((dot) => {
			dot.classList.remove(this.classNames.active);
		});
	}
}

// скролл к началу страницы
const topScroll = (e) => {
	e.preventDefault();

	helpers.scrollTo($('.site'), 1000, 0);
};

const resize = () => {
	if (sb !== null) {
		sb.recalculate();
	}
};

function init(pageName) {
	let currentPage = document.querySelector(`.is-${pageName}`);

	mapLighter = new Dots(currentPage);
	mapLighter.init();

	if (screen.width > 1024) {
		const scrollable = currentPage.querySelectorAll('.article__text-wrapper');

		sb = new SimpleBar(scrollable[scrollable.length - 1], {
			scrollbarMinSize: 12,
			scrollbarMaxSize: 12,
		});
	}

	setTimeout(() => {
		currentPage.querySelector('.article__scrolltop').addEventListener('click', topScroll);
	}, 500);

	window.addEventListener('resize', resize);
}

function destroy(pageName) {
	let currentPage = document.querySelector(`.is-${pageName}`);

	mapLighter.destroy(pageName);
	currentPage.querySelector('.article__scrolltop').removeEventListener('click', topScroll);

	window.removeEventListener('resize', resize);

	sb.unMount();

	sb = null;
}

export default {
	init,
	destroy,
};
